import script from "./SlideDesignPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideDesignPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SlideDesignPanel.vue?vue&type=style&index=0&id=8c16beae&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c16beae"]])

export default __exports__